export class RecordModel {
    id: number;
    startTime: number;
    endTime: number;
    url: string = '';
    totalTime:number = 0;
    position: number = 0;
    index:number = 0;
}